import { ReactNode } from 'react'
import { PlusIcon } from '@heroicons/react/24/outline'
import { NavLink } from 'libs/router'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type CtaLinkProps = WithClassName<{
	text: string
	to: string
	icon?: ReactNode
	variant?: 'primary' | 'outline'
	compact?: boolean
}>

export const ctaClassNames = {
	base: 'inline-flex h-9 items-center justify-center gap-2 whitespace-nowrap rounded-md px-4 text-sm font-medium shadow transition-colors [&>svg]:h-4 [&>svg]:w-4 [&>svg]:shrink-0 [&>svg]:stroke-2',
	primary: 'bg-primary text-primary-foreground hover:bg-primary/90',
	outline: 'border border-border bg-background text-foreground hover:bg-muted'
}

export const CtaLink = ({
	text,
	to,
	className,
	icon = <PlusIcon />,
	variant = 'primary',
	compact = false
}: CtaLinkProps) => {
	const isIconOnlyOnMobile = compact && !!icon

	return (
		<NavLink
			to={to}
			aria-label={isIconOnlyOnMobile ? text : undefined}
			className={cn(
				ctaClassNames.base,
				ctaClassNames[variant],
				isIconOnlyOnMobile && 'w-9 px-0 sm:w-auto sm:px-4',
				className
			)}>
			{icon}
			<span className={isIconOnlyOnMobile ? 'hidden sm:inline' : undefined}>{text}</span>
		</NavLink>
	)
}
